import { ScopedListsManager, type ScopedListsAdapter } from '@platform/ui';
import { api } from '../api';
import { SettingsTabs } from './settings-tabs';

const adapter: ScopedListsAdapter = {
  overview: () => api.myScopedLists(),
  entries: (listId) => api.myScopedListEntries(listId),
  add: (listId, values) => api.addMyScopedListEntries(listId, values),
  remove: (listId, values) => api.removeMyScopedListEntries(listId, values),
  importCsv: (listId, csv) => api.importMyScopedList(listId, csv),
  passwordList: (id) => api.myTypedList(id),
  putKey: (id, keyId, input) => api.putMyPasswordListKey(id, keyId, input),
  deleteKey: (id, keyId, input) => api.deleteMyPasswordListKey(id, keyId, input),
  setShares: (id, input) => api.setMyPasswordListShares(id, input),
  shareGroups: () => api.myShareGroups(),
};

/** Settings > My lists: the signed-in user's entries in the lists the administrator defined, and their password key lists. */
export function MyListsPage() {
  return <div className="min-h-0 flex-1 overflow-y-auto"><ScopedListsManager adapter={adapter} headerTabs={<SettingsTabs active="my-lists" />} /></div>;
}
